import React, { FC } from 'react';
import DesktopLogin from './components/desktopLogin';
import MobileLogin from './components/mobileLogin';

const Login: FC<{ view: 'mobile' | 'desktop'; fields: any; sitecoreContext: any }> = ({ view, fields,sitecoreContext }) => {
  if (view === 'desktop') return <DesktopLogin fields={fields} />;
  if (view === 'mobile') return <MobileLogin fields={fields} />;
  return <></>;
};

export default Login;
